<div class="center">
    <p *ngIf="!isLinked"
    >{{ ('Click the button below and follow the instructions to link {}' | translate).replace('{}', 'Enologia') }}</p>
    <button
            (click)="clickHandler(isLinked ? 'remove' : 'connect')"
            mat-stroked-button
    >
        {{ ( isLinked ? "Remove" : "Link Enologia" ) | translate }}
    </button>
</div>